import * as React from 'react';
import Loader from '../Loader';
import Select from 'antd/lib/select';
import { CommonProps } from './common.intefaces';
import { useDebounce } from 'src/hooks/useDebounce';
import { SEARCH_TIMEOUT } from 'src/Library/Constants';
import { searchCountry } from 'src/api/country';

interface IProps extends CommonProps {
  apiOptions?: CountryApiParams;
  labelInValue?: boolean;
  isExecution?: boolean;
}

interface CountryApiParams {
}

type Country = {
  countryCode: string;
  countryName: string;
  unlocCountryCode: string;
  countryNameAlias: string;
  flagS3Link: string;
  id: string;
};

const SelectCountry = (props: IProps) => {

  const {
    mode,
    style,
    value,
    disabled,
    onChange,
    className,
    apiOptions,
    placeholder,
    labelInValue = true,
    isExecution = false
  } = props;

  const [countries, setCountries] = React.useState<Country[]>([]);
  const [searching, setSearching] = React.useState<boolean>(false);
  const [queryString, setQuery] = React.useState<string>('');

  const handleCountrySearch = async () => {
    setSearching(true);
    const response = await searchCountry({
      queryString,
      ...(apiOptions || {}),
    });
    setCountries(response?.data || []);
    setSearching(false);
  };

  const debounceTime = useDebounce(queryString, SEARCH_TIMEOUT);
  React.useEffect(() => {
    if (debounceTime !== undefined && debounceTime !== '') {
      setSearching(true);
      handleCountrySearch();
    }
  }, [debounceTime]);

  const dropdownRender = (menu) => {
    if (searching) return <div
      style={{ padding: '25px' }}>
      <Loader />
    </div>;
    return menu;
  };

  const renderCountryOptions = ({isExecution}) => {
    return countries?.map((country: Country) =>  <Select.Option
        key={(!isExecution && country.unlocCountryCode) ? country.unlocCountryCode : country.countryCode}
      >
        {country.countryName} ({(!isExecution && country.unlocCountryCode) ? country.unlocCountryCode : country.countryCode})
      </Select.Option> || []
    )
  };

  return <Select
    style={{
      ...(style || {}),
    }}
    value={value}
    allowClear
    showSearch
    labelInValue={labelInValue}
    onChange={onChange}
    className={className}
    mode={mode || 'default'}
    disabled={disabled}
    onSearch={query => setQuery(query)}
    onFocus={() => handleCountrySearch()}
    filterOption={(inputValue, option) => true}
    dropdownRender={dropdownRender}
    placeholder={placeholder || 'Select Country'}
    getPopupContainer={(trigger: any) => trigger.parentNode}
  >
    {renderCountryOptions({isExecution})}
  </Select>;
};


export default React.memo(SelectCountry);
